import { LevelModel } from 'shared/domain/level/types/model';
import { LabelledEntity } from 'shared/types/commonView';
import { DocumentationBaseIds } from 'shared/types/documentation';
import { areObjectIdsEqual } from 'helpers/idComparison';
import { hasDocumentation } from './findDocumentationOnLevels';

export type WarnableLevelChanges = (
    chosenLevels: LabelledEntity[] | undefined,
    levels: LevelModel[],
    currentIds: DocumentationBaseIds
  ) => LevelChangeWarnings;
export interface LevelChangeWarnings {
  replacements: LabelledEntity[];
  removals: LabelledEntity[];
}
export function getWarnableChanges(
  chosenLevels: LabelledEntity[] | undefined,
  levels: LevelModel[],
  currentIds: DocumentationBaseIds
): LevelChangeWarnings {
  const replacements: LabelledEntity[] = [];
  const removals: LabelledEntity[] = [];

  if (!chosenLevels) {
    return {
      replacements,
      removals,
    };
  }

  levels.forEach((level) => {
    if (!level.map) {
      return;
    }
    const isChosen = chosenLevels.some((chosen) => areObjectIdsEqual(chosen._id, level._id));
    const showsThisDocumentation = hasDocumentation(level, currentIds.documentationId);
    const entry = { _id: level._id, label: level.label };

    // A chosen level that shows another documentation gets this one instead.
    if (isChosen && !showsThisDocumentation) {
      replacements.push(entry);
    }
    // A level no longer chosen stops showing this documentation.
    if (!isChosen && showsThisDocumentation) {
      removals.push(entry);
    }
  });

  return {
    replacements,
    removals,
  };
}
